import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    marginTop: 0,
    paddingTop: '8px',
    width: '100%',
    minWidth: 0,
    alignSelf: 'stretch',
  },
  planRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
  },
  planName: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '18px',
    color: theme.evPalette.charcoal[900],
  },
  planUsage: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '18px',
    color: theme.evPalette.charcoal[900],
  },
  progressBar: {
    width: '100%',
    minWidth: 0,
    height: '6px',
    borderRadius: '3px',
    backgroundColor: theme.evPalette.charcoal[200],
    '& .myev-MuiLinearProgress-bar': {
      borderRadius: '3px',
      backgroundColor: theme.evPalette.ocean[600],
    },
  },
  progressBarFull: {
    '& .myev-MuiLinearProgress-bar': {
      // 100%+ usage (overage): marigold-300 (fallback to mango if not present)
      // #genai optional chaining, same fallback order as the previous && guard
      backgroundColor: `${theme.evPalette.marigold?.[300]
        || theme.evPalette.mango[300]
        || theme.evPalette.mango[700]
        || theme.evPalette.ocean[600]} !important`,
    },
  },
  usageCaption: {
    marginTop: '2px',
    fontSize: '12px',
    lineHeight: '16px',
    color: theme.evPalette.charcoal[700],
  },
}));
